<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Counters",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            loading: true,
            submit_loading: false,
            title: "Counters",
            items: [
               {
                  text: "Counters",
                  active: true,
               },                   
            ],

            test: {
               id: null,
               name: "",
               description: "",
               type: "",
               prize: "",
               lab_id: 0,

            },
            test_type: "",
            counters: [],
            test_name: 0,
            test_status: {
               id: "",
               status: "",
            },
            counter_status: {
               id: "",
               status: "",
            },

            file_image: "",
            file_preview_image: "",
            
            modal_title: "Add Counter",
            button_title: "Save",
            pagination: {},
            edit: false,

            type: '',
            keyword: "",
            status: "",
            listing_length: 10,
            token: "",
            errors: {},
            selectedTest: "",
            counter_title: "",
            

            from: "",
            to: "",
            total: "",

            delete: false,
            active_page_url: null,

            counter: {
              type: 1,
              lab_id: null,
              pharmacy_id: null,
              counter_name: '',
              username: '',
              priority_type: 3,
              prefix: null,
              token_management_type: 2,
              scroll_up: 2,
              password: '',
              confirm_password: ''
            },
            pharmacies: [] // Fill with { value: id, text: name }
         };
      },
      mounted() {
         this.clearLocalStorage();
      },


      created(){
         this.fetchCounters();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchCounters(page_url = null){

            this.getToken();

            let url = "lab/counters?&limit=" + this.listing_length + "&keyword=" + this.keyword + "&status=" + this.status;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               //var responseData = res.data.data;
               //console.log(responseData.data);

               // Use responseData.lab and responseData.bookings_count
              

               var responseData = res.data.data;
               this.counters = responseData.counters.data;
               this.counter_title = responseData.counter_title;
               this.from = responseData.counters.from;
               this.to = responseData.counters.to;
               this.total = responseData.counters.total;
               this.pagination = responseData.counters.links;
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));

         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

             updateTitle() {
               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

               let formData = new FormData();
               formData.append("counter_title", this.counter_title); 
      
               let url = "lab/updateCounterTitle";
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('title-modal');
                  this.fetchCounters(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        // console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         addCounter(){

            this.submit_loading = true;
            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "lab/addCounter";
            let formData = new FormData();
            formData.append("counter_name", this.counter.counter_name);
            formData.append("username", this.counter.username);
            formData.append("priority_type", this.counter.priority_type);
            if (this.counter.priority_type == 2) {
               formData.append("prefix", this.counter.prefix || '');
            }
            formData.append("token_management_type", this.counter.token_management_type);
            formData.append("scroll_up", this.counter.scroll_up);
            formData.append("password", this.counter.password);
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.fetchCounters();
                     this.clearForm();
                     this.hideModal('add-counter-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.status === 422) {
                        // Validation errors
                        this.errors = error.response.data.message;
                        console.log('Validation errors:', this.errors);
                     } else if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.submit_loading = false));
         },
         
         getToken() {
            if (localStorage.getItem('medicino_lab')) {
               var medicino_lab = JSON.parse(localStorage.getItem('medicino_lab'));
               if (medicino_lab.token) {
                  this.token = medicino_lab.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }

            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         showModal(modal) {
            this.errors = {}; // Clear any previous errors
            this.$refs[modal].show();
         },
         openAddCounterModal() {
            this.errors = {}; // Clear any previous errors
            this.counter = {
              type: 1,
              lab_id: null,
              counter_name: '',
              username: '',
              priority_type: 3,
              prefix: null,
              token_management_type: 2,
              scroll_up: 2,
              password: ''
            };
            this.showModal('add-counter-modal');
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },

         getTokenManagementTypeLabel(type) {
            if (type == 2) return 'Current token tracking';
            if (type == 3) return 'OP outsource';
            return '-';
         },

         formatDate(dateString) {
            const date = new Date(dateString);

            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();

            const hours = date.getHours();
            const minutes = date.getMinutes();

            return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
         },


         clearForm() {
            this.edit = false;
            this.modal_title = "Add Counter";
            this.button_title = "Save";
            this.errors = {};
            this.counter = {
              type: 1,
              lab_id: null,
              counter_name: '',
              username: '',
              priority_type: 3,
              prefix: null,
              token_management_type: 2,
              scroll_up: 2,
              password: '',
              confirm_password: ''
            }; 
         },
         
         editCounter(counter) {
            this.edit = true;
            this.counter.id = counter.id;
            this.counter.counter_name = counter.counter_name;
            this.counter.username = counter.username;
            this.counter.priority_type = counter.priority_type;
            this.counter.prefix = counter.prefix || null;
            this.counter.token_management_type = counter.token_management_type || 2;
            this.counter.scroll_up = counter.scroll_up || 2;
            
            this.errors = {};
            this.modal_title = "Edit Counter";
            this.button_title = "Update";
            
            this.showModal('edit-counter-modal');
         },

         updateCounter() {
            this.submit_loading = true;
            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "lab/updateCounter";
            let formData = new FormData();
            formData.append("id", this.counter.id);
            formData.append("counter_name", this.counter.counter_name);
            formData.append("username", this.counter.username);
            formData.append("priority_type", this.counter.priority_type);
            if (this.counter.priority_type == 2) {
               formData.append("prefix", this.counter.prefix || '');
            }
            formData.append("token_management_type", this.counter.token_management_type);
            formData.append("scroll_up", this.counter.scroll_up);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.fetchCounters();
                     this.clearForm();
                     this.hideModal('edit-counter-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.status === 422) {
                        // Validation errors
                        this.errors = error.response.data.message;
                        console.log('Validation errors:', this.errors);
                     } else if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.submit_loading = false));
         },

         changePassword(counter) {
            this.counter.id = counter.id;
            this.counter.counter_name = counter.counter_name;
            this.counter.password = '';
            this.counter.confirm_password = '';
            
            this.errors = {};
            this.showModal('change-password-modal');
         },

         updatePassword() {
            // Validate password confirmation
            if (this.counter.password !== this.counter.confirm_password) {
               this.errors = { confirm_password: ['Password and confirm password must be same'] };
               return;
            }

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "lab/CounterChangePassword";
            let formData = new FormData();
            formData.append("counter_id", this.counter.id);
            formData.append("password", this.counter.password);
            formData.append("password_confirmation", this.counter.confirm_password);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.clearForm();
                     this.hideModal('change-password-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.status === 422) {
                        // Validation errors
                        this.errors = error.response.data.message;
                        console.log('Validation errors:', this.errors);
                     } else if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         activateCounter(counter) {
            this.activate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to publish this counter?', {
               title: 'Confirm',
               size: 'sm',
               buttonSize: 'sm',
               okVariant: 'danger',
               okTitle: 'Yes',
               cancelTitle: 'No',
               footerClass: 'p-2',
               hideHeaderClose: false,
               centered: true
            })
            .then(value => {
               this.activate = value
               if(this.activate){
                  this.counter_status.id = counter.id;
                  this.counter_status.status = 1;
                  this.updateCounterStatus();
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         deactivateCounter(counter) {
            this.deactivate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to block this counter?', {
               title: 'Confirm',
               size: 'sm',
               buttonSize: 'sm',
               okVariant: 'danger',
               okTitle: 'Yes',
               cancelTitle: 'No',
               footerClass: 'p-2',
               hideHeaderClose: false,
               centered: true
            })
            .then(value => {
               this.deactivate = value
               if(this.deactivate){
                  this.counter_status.id = counter.id;
                  this.counter_status.status = 2;
                  this.updateCounterStatus();
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         updateCounterStatus() {
            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "lab/updateCounterStatus?counter_id=" + this.counter_status.id + "&status=" + this.counter_status.status;

            this.$axios
               .get(url, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.fetchCounters();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
            counterDelete(counter) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this counter account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "lab/deleteCounter";
                     let formData = new FormData();
                     formData.append("counter_id", counter.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchCounters();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->

                  <div class="row mb-4">
                     <div class="col-12">
                         <h5>Normal Counter Display Name : {{ counter_title }} </h5>
                        <b-button @click="openAddCounterModal" variant="primary" class="float-end me-2">Add Counter</b-button>
                        <b-button v-b-modal.title-modal variant="primary" class="float-end me-2">Update Normal Counter Display Name</b-button>
                     </div>
                  </div>

                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchCounters()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"  @keyup="fetchCounters()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status"  @change="fetchCounters()">
                              <option value="">All</option>
                              <option value="1">Active</option>
                              <option value="2">Blocked</option>
                           </select>
                           </label>
                        </div> 
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

      <thead class="table-light">
         <tr>
            <th width="15%">Name</th> 
            <th width="15%">User Name</th>
            <th width="8%">Priority Type</th>
            <th width="10%">Prefix</th>
            <th width="12%">Token Management Type</th>
            <th width="8%">Scroll Up</th>
            <th width="10%">Status</th>
            <th width="10%">Created On</th>
            <th width="15%">Options</th>
         </tr>
      </thead>

      <tbody v-if="Boolean(counters.length)">
         <tr v-for="counter in counters" :key="counter.id">
            <td>{{ counter.counter_name }}</td>
            <td>{{ counter.username}}</td>
            <td>
               {{ counter.priority_type == 1 ? 'Yes' : counter.priority_type == 2 ? 'Yes' : 'No' }}
            </td>
            <td>
               <span v-if="counter.priority_type == 2">{{ counter.prefix || '-' }}</span>
               <span v-else>-</span>
            </td>
            <td>{{ getTokenManagementTypeLabel(counter.token_management_type) }}</td>
            <td>{{ counter.scroll_up == 1 ? 'Yes' : 'No' }}</td>
            <td>
               <span v-if="counter.status==1" class="badge bg-success">Active</span>
               <span v-else-if="counter.status==2" class="badge bg-danger">Blocked</span>
               <span v-else class="badge bg-warning">Inactive</span>
            </td>
            <td>{{ formatDate(counter.created_at) }}</td>
            <td>
               <b-button variant="danger" class="btn-sm mb-2 me-2" @click="changePassword(counter)"><i class='bx bxs-key'></i></b-button>
               <b-button variant="primary" class="btn-sm me-2 mb-2" @click="editCounter(counter)">Edit</b-button>
               <b-button v-if="counter.status==1" variant="warning" class="btn-sm mb-2 me-2" @click="deactivateCounter(counter)">Block</b-button>
               <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateCounter(counter)">Publish</b-button>
               <b-button variant="danger" class="btn-sm me-2 mb-2" @click="counterDelete(counter)" >Delete</b-button>
            </td>
         </tr>
      </tbody>
      <tbody v-else>
         <tr>
            <td colspan="9" class="text-center">No counters found</td>
         </tr>
      </tbody>

</table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(counters.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchCounters(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                     
                  <!----pagination ends --->

                  <b-modal ref="add-counter-modal" id="add-counter-modal" title="Add Counter" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="addCounter">

                      <b-form-group class="col-sm-12 col-md-12">
                        <label for="priority_type" class="form-label">Is Priority Counter? <span class="text-danger">*</span></label>
                        <select
                          class="form-control"
                          v-model="counter.priority_type"
                          v-bind:class="{ 'is-invalid': Boolean(errors.priority_type) }"
                          required
                        >
                          <option :value="2">Yes</option>
                          <option :value="3">No</option>
                        </select>
                        <div v-for="(val, index) in errors.priority_type" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group v-if="counter.priority_type == 2">
                        <label for="prefix" class="form-label">Prefix</label>
                        <b-form-input 
                          v-model="counter.prefix" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.prefix) }"
                          placeholder="Enter prefix (optional)"
                        ></b-form-input>
                        <div v-for="(val, index) in errors.prefix" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <label class="form-label">Token Management Type <span class="text-danger">*</span></label>
                        <b-form-radio-group
                          v-model="counter.token_management_type"
                          name="counterTokenTypeAdd"
                          :class="{ 'is-invalid': Boolean(errors.token_management_type) }"
                          inline
                        >
                          <b-form-radio :value="2">Current token tracking</b-form-radio>
                          <b-form-radio :value="3">OP outsource</b-form-radio>
                        </b-form-radio-group>
                        <div v-for="(val, index) in errors.token_management_type" :key="index" class="invalid-feedback d-block">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <b-form-checkbox v-model="counter.scroll_up" :value="1" :unchecked-value="2">
                          Scroll Up
                        </b-form-checkbox>
                        <div v-for="(val, index) in errors.scroll_up" :key="index" class="invalid-feedback d-block">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>
                      
                      <b-form-group>
                      <label for="counter_name" class="form-label">Counter Name <span class="text-danger">*</span></label>
                        <b-form-input 
                          v-model="counter.counter_name" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.counter_name) }"
                          required
                        ></b-form-input>
                        <div v-for="(val, index) in errors.counter_name" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <label for="username" class="form-label">Username <span class="text-danger">*</span></label>
                        <b-form-input 
                          v-model="counter.username" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.username) }"
                          required
                        ></b-form-input>
                        <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                        <b-form-input 
                          type="password" 
                          v-model="counter.password" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.password) }"
                          required 
                          minlength="6" 
                          maxlength="16"
                        ></b-form-input>
                        <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-button type="submit" variant="primary" :disabled="submit_loading">
                        <span v-if="submit_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Save
                      </b-button>
                      <b-button variant="light" @click="hideModal('add-counter-modal')">Close</b-button>
                    </b-form>
                  </b-modal>

                  <b-modal ref="edit-counter-modal" id="edit-counter-modal" title="Edit Counter" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="updateCounter">

                      <b-form-group class="col-sm-12 col-md-12">
                        <label for="priority_type" class="form-label">Is Priority Counter? <span class="text-danger">*</span></label>
                        <select
                          class="form-control"
                          v-model="counter.priority_type"
                          v-bind:class="{ 'is-invalid': Boolean(errors.priority_type) }"
                          required
                        >
                          <option :value="2">Yes</option>
                          <option :value="3">No</option>
                        </select>
                        <div v-for="(val, index) in errors.priority_type" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group v-if="counter.priority_type == 2">
                        <label for="prefix" class="form-label">Prefix</label>
                        <b-form-input 
                          v-model="counter.prefix" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.prefix) }"
                          placeholder="Enter prefix (optional)"
                        ></b-form-input>
                        <div v-for="(val, index) in errors.prefix" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <label class="form-label">Token Management Type <span class="text-danger">*</span></label>
                        <b-form-radio-group
                          v-model="counter.token_management_type"
                          name="counterTokenTypeEdit"
                          :class="{ 'is-invalid': Boolean(errors.token_management_type) }"
                          inline
                        >
                          <b-form-radio :value="2">Current token tracking</b-form-radio>
                          <b-form-radio :value="3">OP outsource</b-form-radio>
                        </b-form-radio-group>
                        <div v-for="(val, index) in errors.token_management_type" :key="index" class="invalid-feedback d-block">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <b-form-checkbox v-model="counter.scroll_up" :value="1" :unchecked-value="2">
                          Scroll Up
                        </b-form-checkbox>
                        <div v-for="(val, index) in errors.scroll_up" :key="index" class="invalid-feedback d-block">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>
                      
                      <b-form-group>
                        <label for="counter_name" class="form-label">Counter Name <span class="text-danger">*</span></label>
                        <b-form-input 
                          v-model="counter.counter_name" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.counter_name) }"
                          required
                        ></b-form-input>
                        <div v-for="(val, index) in errors.counter_name" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <label for="username" class="form-label">Username <span class="text-danger">*</span></label>
                        <b-form-input 
                          v-model="counter.username" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.username) }"
                          required
                        ></b-form-input>
                        <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                      <b-button type="submit" variant="primary" :disabled="submit_loading">
                        <span v-if="submit_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Update
                      </b-button>
                      <b-button variant="light" @click="hideModal('edit-counter-modal')">Close</b-button>
                    </b-form>
                  </b-modal>

                  <b-modal ref="change-password-modal" id="change-password-modal" title="Change Password" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="updatePassword">

                      <b-form-group>
                        <label for="password" class="form-label">New Password <span class="text-danger">*</span></label>
                        <b-form-input 
                          type="password" 
                          v-model="counter.password" 
                          v-bind:class="{ 'is-invalid': Boolean(errors.password) }"
                          required 
                          minlength="6" 
                          maxlength="16"
                        ></b-form-input>
                        <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                          <p class="mb-0">{{ val }}</p>
                        </div>
                      </b-form-group>

                       <b-form-group>
                        <label for="confirm_password" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                         <b-form-input 
                           type="password" 
                           v-model="counter.confirm_password" 
                           v-bind:class="{ 'is-invalid': Boolean(errors.confirm_password) }"
                           required 
                           minlength="6" 
                           maxlength="16"  
                         ></b-form-input>
                         <div v-for="(val, index) in errors.confirm_password" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                         </div>
                       </b-form-group>

                      <b-button type="submit" variant="primary">Change Password</b-button>
                      <b-button variant="light" @click="hideModal('change-password-modal')">Close</b-button>
                    </b-form>
                  </b-modal>

                      <!---- modal starts ---->
                  <b-modal ref="title-modal" id="title-modal" title="Update Normal Counter Display Name" hide-footer @hidden="clearForm()">
                     <b-form  @submit.prevent="updateTitle()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Title<span class="text-danger">*</span></label>
                           <b-form-input v-model="counter_title"></b-form-input>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                              <b-button class="" variant="light" @click="hideModal('title-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
